import React from 'react';
import './TemplatePhonePreview.css';

function exampleValues(component, kind) {
  const named = component?.example?.[`${kind}_text_named_params`];
  if (Array.isArray(named)) return Object.fromEntries(named.map(item => [item.param_name, item.example]));
  const positional = component?.example?.[`${kind}_text`];
  return kind === 'body' ? (Array.isArray(positional?.[0]) ? positional[0] : typeof positional === 'string' ? [positional] : positional || []) : (positional || []);
}

function renderText(text, values = []) {
  return String(text || '').split(/(\{\{\s*[a-zA-Z_][a-zA-Z_0-9]*\s*\}\}|\{\{\s*\d+\s*\}\})/g).map((part, index) => {
    const match = part.match(/^\{\{\s*([a-zA-Z_][a-zA-Z_0-9]*|\d+)\s*\}\}$/);
    if (!match) return <React.Fragment key={index}>{part}</React.Fragment>;
    const value = String(Array.isArray(values) ? values[Number(match[1]) - 1] || '' : values[match[1]] || '').trim();
    return value
      ? <strong className="template-phone-value" key={index}>{value}</strong>
      : <span className="template-phone-missing" key={index}>{part}</span>;
  });
}

export default function TemplatePhonePreview({ template, businessName = 'Your Business', bodyValues, headerValues, mediaUrl }) {
  const components = template?.components || [];
  const header = components.find(item => item.type === 'HEADER');
  const body = components.find(item => item.type === 'BODY');
  const footer = components.find(item => item.type === 'FOOTER');
  const buttons = components.find(item => item.type === 'BUTTONS')?.buttons || [];
  const carousel = components.find(item => item.type === 'CAROUSEL');
  const offer = components.find(item => item.type === 'LIMITED_TIME_OFFER');
  const otherComponents = components.filter(item => !['HEADER', 'BODY', 'FOOTER', 'BUTTONS', 'CAROUSEL', 'LIMITED_TIME_OFFER'].includes(item.type));
  const resolvedBody = bodyValues || exampleValues(body, 'body');
  const resolvedHeader = headerValues || exampleValues(header, 'header');

  return (
    <div className="template-phone-wrap">
      <div className="template-phone" aria-label="Illustrative WhatsApp message preview">
        <div className="template-phone-status"><span>12:00</span><span className="template-phone-notch" /><span>▰ ▴</span></div>
        <div className="template-phone-chat-header">
          <span className="template-phone-back">‹</span>
          <span className="template-phone-avatar">{businessName[0]?.toUpperCase() || 'B'}</span>
          <span className="template-phone-business"><strong>{businessName}</strong><small>online</small></span>
          <span className="template-phone-actions">📞 ⋮</span>
        </div>
        <div className="template-phone-chat">
          <div className="template-phone-day"><span>Today</span></div>
          <div className="template-phone-message">
            {header?.format === 'TEXT' && header.text && (
              <div className="template-phone-text-header">{renderText(header.text, resolvedHeader)}</div>
            )}
            {header?.format && header.format !== 'TEXT' && (
              mediaUrl && header.format === 'IMAGE'
                ? <img className="template-phone-media" src={mediaUrl} alt="Template header preview" />
                : <div className="template-phone-media-placeholder">
                    <span>{header.format === 'IMAGE' ? '🖼️' : header.format === 'VIDEO' ? '🎬' : '📄'}</span>
                    <small>{header.format.toLowerCase()} header</small>
                  </div>
            )}
            {offer && <div className="template-phone-offer">⏳ {offer.limited_time_offer?.text || 'Limited-time offer'}{offer.limited_time_offer?.has_expiration ? ' · Countdown at send time' : ''}</div>}
            <div className="template-phone-body">{renderText(body?.text || 'Your message will appear here.', resolvedBody)}</div>
            {footer?.text && <div className="template-phone-footer">{footer.text}</div>}
            <div className="template-phone-time">12:00 ✓✓</div>
          </div>
          {carousel && <div className="template-phone-carousel" aria-label="Carousel cards">
            {(carousel.cards || []).map((card, index) => {
              const cardBody = card.components?.find(item => item.type === 'BODY');
              const cardHeader = card.components?.find(item => item.type === 'HEADER');
              const cardButtons = card.components?.find(item => item.type === 'BUTTONS')?.buttons || [];
              return <div className="template-phone-carousel-card" key={index}>
                {cardHeader && <div className="template-phone-media-placeholder"><span>🖼️</span><small>card {index + 1} media</small></div>}
                {cardBody?.text && <div className="template-phone-body">{renderText(cardBody.text, exampleValues(cardBody, 'body'))}</div>}
                {cardButtons.map((button, buttonIndex) => <div className="template-phone-button" key={buttonIndex}>{button.text || button.type}</div>)}
              </div>;
            })}
          </div>}
          {otherComponents.map((component, index) => <div className="template-phone-unsupported" key={index}>
            {String(component.type || 'Additional').replace(/_/g, ' ').toLowerCase()} content
          </div>)}
          {buttons.length > 0 && <div className="template-phone-buttons">
            {buttons.map((button, index) => <div className="template-phone-button" key={index}>
              {button.type === 'URL' ? '🔗 ' : button.type === 'PHONE_NUMBER' ? '📞 ' : '↩️ '}{button.text || button.type}
            </div>)}
          </div>}
        </div>
        <div className="template-phone-compose"><span>Message</span><b>🎤</b></div>
        <div className="template-phone-home"><span /></div>
      </div>
      <p className="template-phone-note">Illustrative preview. The recipient’s device and send-time values may differ.</p>
    </div>
  );
}
